import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mt_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("mt_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// Parse a plain YYYY-MM-DD date string (no timezone conversion).
export function parseYMD(value) {
  if (!value) return null;
  const m = String(value).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return { y: +m[1], mo: +m[2], d: +m[3] };
}

// Format a date-only value as "Month D, YYYY" exactly as entered, no timezone shift.
export function formatDate(value) {
  const p = parseYMD(value);
  if (!p) return value ? String(value) : "";
  const month = MONTHS[p.mo - 1];
  if (!month) return String(value);
  return `${month} ${p.d}, ${p.y}`;
}

// Compute payroll summary stats for one employee from real payroll records.
export function employeePayrollStats(records = []) {
  const now = new Date();
  const curY = now.getFullYear();
  const curMo = now.getMonth() + 1;
  const s = {
    balance: 0,
    monthHours: 0, monthJobs: 0, monthPayroll: 0,
    ytdHours: 0, ytdJobs: 0, ytdPayroll: 0,
    allTimePayroll: 0, allTimeJobs: 0, avgPerJob: 0,
  };
  for (const r of records) {
    const gross = Number(r.gross_pay || 0);
    const net = r.net_pay != null ? Number(r.net_pay) : gross - Number(r.deductions || 0);
    const hours = Number(r.hours || 0);
    const jobs = Number(r.jobs_completed || 0);
    if ((r.status || "Pending") !== "Paid") s.balance += net;
    s.allTimePayroll += gross;
    s.allTimeJobs += jobs;
    const p = parseYMD(r.period_start) || parseYMD(r.created_at);
    if (p && p.y === curY) {
      s.ytdHours += hours; s.ytdJobs += jobs; s.ytdPayroll += gross;
      if (p.mo === curMo) { s.monthHours += hours; s.monthJobs += jobs; s.monthPayroll += gross; }
    }
  }
  s.avgPerJob = s.allTimeJobs > 0 ? s.allTimePayroll / s.allTimeJobs : 0;
  return s;
}

export default api;
